import React from 'react';
import { DeleteReason } from '../../types/interview';

interface DeletedMediaPlaceholderProps {
  deleteReason?: DeleteReason | null;
  variant: 'card' | 'player';
}

// Centralized copy for the VI-468 deleted-media UI. Default branch
// covers 'Passed 2-year retention' AND null/unknown reasons so a
// missing/unexpected value never leaks the harsher jobseeker copy.
export const getDeletedMediaMessage = (deleteReason?: DeleteReason | null): string => {
  if (deleteReason === 'Jobseeker requested deletion') {
    return "This media has been deleted at the jobseeker's request.";
  }
  return 'This media is no longer available.';
};

const DeletedMediaPlaceholder: React.FC<DeletedMediaPlaceholderProps> = ({
  deleteReason,
  variant,
}) => {
  const isPlayer = variant === 'player';
  const message = getDeletedMediaMessage(deleteReason);

  return (
    <div
      role="img"
      aria-label={message}
      style={{
        width: '100%',
        height: '100%',
        aspectRatio: '16/9',
        borderRadius: isPlayer ? '16px' : '8px',
        backgroundColor: '#E9ECEF',
        color: '#3F4254',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: isPlayer ? '2rem' : '0.75rem',
        boxSizing: 'border-box',
      }}
    >
      <span
        style={{
          fontWeight: 500,
          fontSize: isPlayer ? '1.125rem' : '0.85rem',
          lineHeight: 1.4,
          maxWidth: isPlayer ? '60%' : '100%',
        }}
      >
        {message}
      </span>
    </div>
  );
};

export default DeletedMediaPlaceholder;
